import { render, staticRenderFns } from "./Artboard.vue?vue&type=template&id=12658c56&scoped=true&"
import script from "./Artboard.vue?vue&type=script&lang=js&"
export * from "./Artboard.vue?vue&type=script&lang=js&"
import style0 from "./Artboard.vue?vue&type=style&index=0&id=12658c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12658c56",
  null
  
)

export default component.exports